/*
 * Creates opaque iframe underneath element --- typically used to show content atop a browser plugin (eg Adobe Reader in Internet Explorer
 * To address memory leak: maybe apply resize library directly to the shim; currently only use case was for modal dialog,
 * where it's implemented directly.
*/


(function($) {

    $.fn.iframeShim = function(method) {
       
        var self = this;

        var methods = {
            init: function() {
                this.data('$shim', $('<iframe class="iframeShim hide" scrolling="no" frameborder="0"></iframe>').insertBefore(this));
                sizeAndPosition();
                this.data('$shim').removeClass('hide');
                $(window).on('resize scroll', sizeAndPosition); //TODO: this is causing a leak -- self referenced in the fn
                return this;
            },
            destroy: function () {
                $(window).off('resize scroll', sizeAndPosition);
                if (this.data('$shim')) {
                    this.data('$shim').remove();
                    this.data('$shim', null);
                }
                return this;
            },
            sizeAndPosition: function() { // do externally if needed
                sizeAndPosition();
            }
        };

        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist');
        }


        function sizeAndPosition() {

            var $shim = self.data('$shim');

            //TODO: prevent occurrence
            if (!$shim)
                return;

            /*
            * 8/26/19 -- change to getBoundingClientRect:
            * Use instead of jQuery, at least for outerWidth, outerHeight to avoid rounding issues (DVBC-1615)
            * Works IE9+
            * Note: unline jQuery.offset(), scrolling its taken into account for top, left
            * */

            var rect = self[0].getBoundingClientRect();

            $shim.css({
                width: rect.width,
                height: rect.height,
                top: rect.top,
                left: rect.left,
                'z-index': self.css('z-index') - 1, // make one less than layer of current
                position: 'fixed' //(getting rel to document)
            });

        }

    };

})(jQuery);




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/iframeShim.js
 ** module id = 115
 ** module chunks = 0
 **/